var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", [
    _c(
      "div",
      { staticClass: "layout" },
      [
        _c("div", { staticClass: "layout__header" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "layout__controls" }, [
            _c("div", { staticClass: "form-inline" }, [
              _vm.superadmin === "S"
                ? _c(
                    "button",
                    {
                      staticClass: "btn-primary",
                      attrs: { type: "button" },
                      on: { click: _vm.abrirPreferencias }
                    },
                    [
                      _c("i", { staticClass: "fa fa-cog" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Preferencias")])
                    ]
                  )
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__main" }, [
          _c("div", { staticClass: "layout__main-form" }, [
            _c("div", { staticClass: "row mb-0" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c("div", { staticClass: "card" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "card__content" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    placeholder: "Nombre comercial o abreviado",
                                    type: "text",
                                    id: "nombre_abreviado"
                                  },
                                  model: {
                                    value: _vm.form.nombre_comercial,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "nombre_comercial",
                                        $$v
                                      )
                                    },
                                    expression: "form.nombre_comercial"
                                  }
                                },
                                [
                                  _c("span", [_vm._v("Nombre comercial *")]),
                                  _vm._v(" "),
                                  _vm.errores.nombre_comercial
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores.nombre_comercial[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    placeholder:
                                      "Razón social de la empresa o persona",
                                    type: "text",
                                    id: "razon_social"
                                  },
                                  model: {
                                    value: _vm.form.razon_social,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "razon_social", $$v)
                                    },
                                    expression: "form.razon_social"
                                  }
                                },
                                [
                                  _c("span", [_vm._v("Razón social *")]),
                                  _vm._v(" "),
                                  _vm.errores.razon_social
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores.razon_social[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    placeholder: "Número de RUC",
                                    type: "text",
                                    id: "ruc_empresa"
                                  },
                                  model: {
                                    value: _vm.form.ruc_contribuyente,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "ruc_contribuyente",
                                        $$v
                                      )
                                    },
                                    expression: "form.ruc_contribuyente"
                                  }
                                },
                                [
                                  _c("span", [_vm._v("RUC *")]),
                                  _vm._v(" "),
                                  _vm.errores.ruc_contribuyente
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores.ruc_contribuyente[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    placeholder: "Página web",
                                    type: "text",
                                    id: "paginaWeb"
                                  },
                                  model: {
                                    value: _vm.form.sitio_web,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "sitio_web", $$v)
                                    },
                                    expression: "form.sitio_web"
                                  }
                                },
                                [
                                  _c("span", [_vm._v("Página web")]),
                                  _vm._v(" "),
                                  _vm.errores.pagina_web
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.errores.pagina_web[0])
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    vMoney: "",
                                    format: _vm.porcentaje,
                                    placeholder: "% ##.##",
                                    type: "text",
                                    id: "retencionProductos"
                                  },
                                  model: {
                                    value: _vm.form.retencion_productos,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "retencion_productos",
                                        $$v
                                      )
                                    },
                                    expression: "form.retencion_productos"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v("% Retención de productos")
                                  ]),
                                  _vm._v(" "),
                                  _vm.errores.retencion_productos
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores
                                                  .retencion_productos[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    vMoney: "",
                                    format: _vm.porcentaje,
                                    placeholder: "% ##.##",
                                    type: "text",
                                    id: "retencionServicios"
                                  },
                                  model: {
                                    value: _vm.form.retencion_servicios,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "retencion_servicios",
                                        $$v
                                      )
                                    },
                                    expression: "form.retencion_servicios"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v("% Retención de servicios")
                                  ]),
                                  _vm._v(" "),
                                  _vm.errores.retencion_servicios
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores
                                                  .retencion_servicios[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    vMoney: "",
                                    format: _vm.money,
                                    placeholder: "$ ##.##",
                                    type: "text",
                                    id: "comision_base"
                                  },
                                  model: {
                                    value: _vm.form.comision_base,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "comision_base", $$v)
                                    },
                                    expression: "form.comision_base"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v("Monto base de comisiones")
                                  ]),
                                  _vm._v(" "),
                                  _vm.errores.comision_base
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores.comision_base[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    vMoney: "",
                                    format: _vm.porcentaje,
                                    placeholder: "% ##.##",
                                    type: "text",
                                    id: "porcentaje_comision"
                                  },
                                  model: {
                                    value: _vm.form.porcentaje_comision,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "porcentaje_comision",
                                        $$v
                                      )
                                    },
                                    expression: "form.porcentaje_comision"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v("% Porcentaje de comisión")
                                  ]),
                                  _vm._v(" "),
                                  _vm.errores.porcentaje_comision
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores
                                                  .porcentaje_comision[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    placeholder: "Correo electrónico",
                                    type: "text",
                                    id: "email"
                                  },
                                  model: {
                                    value: _vm.form.email_empresa,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "email_empresa", $$v)
                                    },
                                    expression: "form.email_empresa"
                                  }
                                },
                                [
                                  _c("span", [_vm._v("E-mail")]),
                                  _vm._v(" "),
                                  _vm.errores.email_empresa
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores.email_empresa[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    placeholder:
                                      "Dirección de la empresa o persona",
                                    type: "text",
                                    id: "direccion"
                                  },
                                  model: {
                                    value: _vm.form.direccion_empresa,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "direccion_empresa",
                                        $$v
                                      )
                                    },
                                    expression: "form.direccion_empresa"
                                  }
                                },
                                [
                                  _c("span", [_vm._v("Dirección *")]),
                                  _vm._v(" "),
                                  _vm.errores.direccion_empresa
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores.direccion_empresa[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    vMoney: "",
                                    format: _vm.int,
                                    type: "text",
                                    id: "telefono_1",
                                    placeholder: "Teléfono principal"
                                  },
                                  model: {
                                    value: _vm.form.telefono,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "telefono", $$v)
                                    },
                                    expression: "form.telefono"
                                  }
                                },
                                [
                                  _c("span", [_vm._v("Teléfono 1")]),
                                  _vm._v(" "),
                                  _vm.errores.telefono
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.errores.telefono[0])
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    vMoney: "",
                                    format: _vm.int,
                                    type: "text",
                                    id: "telefono_2",
                                    placeholder: "Teléfono secundario"
                                  },
                                  model: {
                                    value: _vm.form.telefono2,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "telefono2", $$v)
                                    },
                                    expression: "form.telefono2"
                                  }
                                },
                                [
                                  _c("span", [_vm._v("Teléfono 2")]),
                                  _vm._v(" "),
                                  _vm.errores.telefono2
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.errores.telefono2[0])
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    type: "text",
                                    id: "fax",
                                    placeholder: "Fax de la empresa o persona"
                                  },
                                  model: {
                                    value: _vm.form.fax,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "fax", $$v)
                                    },
                                    expression: "form.fax"
                                  }
                                },
                                [
                                  _c("span", [_vm._v("FAX")]),
                                  _vm._v(" "),
                                  _vm.errores.fax
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.errores.fax[0]))
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c("div", { staticClass: "form-field select2" }, [
                            _c(
                              "div",
                              { staticClass: "select2-field" },
                              [
                                _c("v-select", {
                                  attrs: {
                                    options: _vm.paises,
                                    label: "nombre",
                                    id: "pais",
                                    placeholder: "Seleccione..."
                                  },
                                  model: {
                                    value: _vm.selectedPais,
                                    callback: function($$v) {
                                      _vm.selectedPais = $$v
                                    },
                                    expression: "selectedPais"
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", { attrs: { for: "pais" } }, [
                                  _vm._v("País")
                                ])
                              ],
                              1
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c("div", { staticClass: "form-field select2" }, [
                            _c(
                              "div",
                              { staticClass: "select2-field" },
                              [
                                _c("v-select", {
                                  attrs: {
                                    options: _vm.provincias,
                                    label: "nombre",
                                    id: "pais",
                                    placeholder: "Seleccione..."
                                  },
                                  model: {
                                    value: _vm.selectedProvincia,
                                    callback: function($$v) {
                                      _vm.selectedProvincia = $$v
                                    },
                                    expression: "selectedProvincia"
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", { attrs: { for: "pais" } }, [
                                  _vm._v("Provincia")
                                ])
                              ],
                              1
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c("div", { staticClass: "form-field select2" }, [
                            _c(
                              "div",
                              { staticClass: "select2-field" },
                              [
                                _c("v-select", {
                                  attrs: {
                                    options: _vm.ciudades,
                                    label: "nombre",
                                    id: "ciudad",
                                    placeholder: "Seleccione..."
                                  },
                                  model: {
                                    value: _vm.selectedCiudad,
                                    callback: function($$v) {
                                      _vm.selectedCiudad = $$v
                                    },
                                    expression: "selectedCiudad"
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", { attrs: { for: "ciudad" } }, [
                                  _vm._v("Ciudad")
                                ]),
                                _vm._v(" "),
                                _vm.errores.ciudad
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(_vm._s(_vm.errores.ciudad[0]))
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c("div", { staticClass: "form-field" }, [
                            _c(
                              "label",
                              { attrs: { for: "contribuyente_especial" } },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.contribuyente_especial,
                                      expression: "form.contribuyente_especial"
                                    }
                                  ],
                                  staticClass: "is-filled",
                                  attrs: {
                                    type: "checkbox",
                                    id: "contribuyente_especial"
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.form.contribuyente_especial
                                    )
                                      ? _vm._i(
                                          _vm.form.contribuyente_especial,
                                          null
                                        ) > -1
                                      : _vm.form.contribuyente_especial
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.form.contribuyente_especial,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.form,
                                              "contribuyente_especial",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.form,
                                              "contribuyente_especial",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.form,
                                          "contribuyente_especial",
                                          $$c
                                        )
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Contribuyente especial")])
                              ]
                            ),
                            _vm._v(" "),
                            _vm.errores.contribuyente_especial
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errores.contribuyente_especial[0]
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.contribuyente_especial,
                              expression: "form.contribuyente_especial"
                            }
                          ],
                          staticClass: "col-xs-12 col-md-6 col-lg-4"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    id: "resContribuyenteEspecial",
                                    placeholder: "N° de contribuyente"
                                  },
                                  model: {
                                    value: _vm.form.numero_cont_espec,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "numero_cont_espec",
                                        $$v
                                      )
                                    },
                                    expression: "form.numero_cont_espec"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v("Res. Contribuyente Especial")
                                  ]),
                                  _vm._v(" "),
                                  _vm.errores.numero_cont_espec
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores.numero_cont_espec[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    id: "detalle_adicional_venta",
                                    placeholder: "Escriba un detalle..."
                                  },
                                  model: {
                                    value: _vm.form.detalle_adicional_venta,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "detalle_adicional_venta",
                                        $$v
                                      )
                                    },
                                    expression: "form.detalle_adicional_venta"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v("Detalle adicional de venta")
                                  ]),
                                  _vm._v(" "),
                                  _vm.errores.detalle_adicional_venta
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores
                                                  .detalle_adicional_venta[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c("div", { staticClass: "form-field" }, [
                            _c("label", { attrs: { for: "exportador" } }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.exportador,
                                    expression: "form.exportador"
                                  }
                                ],
                                staticClass: "is-filled",
                                attrs: { type: "checkbox", id: "exportador" },
                                domProps: {
                                  checked: Array.isArray(_vm.form.exportador)
                                    ? _vm._i(_vm.form.exportador, null) > -1
                                    : _vm.form.exportador
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.form.exportador,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.form,
                                            "exportador",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.form,
                                            "exportador",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.form, "exportador", $$c)
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("Exportador")])
                            ]),
                            _vm._v(" "),
                            _vm.errores.exportador
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.errores.exportador[0]))
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c("div", { staticClass: "form-field" }, [
                            _c(
                              "label",
                              { attrs: { for: "obligadoContabilidad" } },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.obligado_contabilidad,
                                      expression: "form.obligado_contabilidad"
                                    }
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    id: "obligadoContabilidad"
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.form.obligado_contabilidad
                                    )
                                      ? _vm._i(
                                          _vm.form.obligado_contabilidad,
                                          null
                                        ) > -1
                                      : _vm.form.obligado_contabilidad
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.form.obligado_contabilidad,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.form,
                                              "obligado_contabilidad",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.form,
                                              "obligado_contabilidad",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.form,
                                          "obligado_contabilidad",
                                          $$c
                                        )
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v("Obligado a llevar contabilidad")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm.errores.obligado_contabilidad
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errores.obligado_contabilidad[0]
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c("div", { staticClass: "card mt-3 max-content" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "card__content" }, [
                    _c("div", { staticClass: "file-logo-upload" }, [
                      _c("img", {
                        staticClass: "file-logo-upload__img",
                        attrs: { id: "logoImg", src: _vm.urlLogo, alt: "Logo" }
                      }),
                      _vm._v(" "),
                      _c(
                        "form",
                        {
                          attrs: {
                            action: _vm.url + "/parametros/imagen",
                            id: "form_imagen",
                            enctype: "multipart/form-data",
                            method: "post"
                          }
                        },
                        [
                          _c("input", {
                            attrs: { type: "hidden", name: "_token" },
                            domProps: { value: _vm.token }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "file-logo-upload__input",
                            attrs: { type: "file", name: "logo", id: "logo" },
                            on: { change: _vm.readUrl }
                          }),
                          _vm._v(" "),
                          _vm._m(3),
                          _vm._v(" "),
                          _vm._m(4)
                        ]
                      )
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "layout__main-buttons" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card__content" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn-success",
                    attrs: { type: "button" },
                    on: { click: _vm.guardarCambios }
                  },
                  [
                    _c("i", { staticClass: "fa fa-save" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Guardar")])
                  ]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "modal",
          {
            ref: "robot",
            attrs: {
              width: "60%",
              clickToClose: false,
              height: "auto",
              scrollable: true,
              name: "robot"
            }
          },
          [
            _c("parametros-bill-bot", {
              on: { cerrarModalBot: _vm.cerrarBillRobot }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "modal",
          {
            ref: "preferencias",
            attrs: {
              width: "85%",
              clickToClose: false,
              height: "auto",
              scrollable: true,
              name: "preferencias"
            }
          },
          [
            _c("parametros-preferencias", {
              on: { cerrar: _vm.cerrarPreferencias }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Parametros del sistema")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información de la empresa")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Logo de la empresa")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "file-logo-upload__label", attrs: { for: "logo" } },
      [_c("i", { staticClass: "fa fa-upload" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "file-logo-upload__button btn-secondary",
        attrs: {
          type: "button",
          onclick: "document.getElementById('form_imagen').submit()"
        }
      },
      [
        _c("i", { staticClass: "fa fa-refresh" }),
        _vm._v(" "),
        _c("span", [_vm._v("Cambiar logo")])
      ]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b02e624", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b02e624","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/parametrizacion/ParametrosGeneral.vue
// module id = 499
// module chunks = 0